import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';
import { useToast } from './Toast';

/** Reused across all 6 reviewer-facing pages - a mandatory-comment Return action, matching the spec's requirement that Return can never be commentless. */
export function ReturnAction({ onReturn, queryKeysToInvalidate }: { onReturn: (comment: string) => Promise<unknown>; queryKeysToInvalidate: unknown[][] }) {
  const { showSuccess, showError } = useToast();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState('');

  const returnMutation = useMutation({
    mutationFn: () => onReturn(comment),
    onSuccess: () => { showSuccess('Returned for redraft.'); queryKeysToInvalidate.forEach((k) => queryClient.invalidateQueries({ queryKey: k })); setOpen(false); setComment(''); },
    onError: (err) => showError(err instanceof ApiError ? err.message : 'Failed to return.'),
  });

  if (!open) return <button className="link-button" onClick={() => setOpen(true)}>Return for Redraft</button>;

  return (
    <span className="return-action-inline">
      <input placeholder="Reason (required)" value={comment} onChange={(e) => setComment(e.target.value)} />
      <button className="link-button" onClick={() => comment.trim() ? returnMutation.mutate() : showError('A reason is required.')} disabled={returnMutation.isPending}>
        {returnMutation.isPending ? 'Returning…' : 'Confirm Return'}
      </button>
      <button className="link-button" onClick={() => setOpen(false)}>Cancel</button>
    </span>
  );
}
